export default "__VITE_ASSET__33c5839c__"